import { render, staticRenderFns } from "./prizeInfo.vue?vue&type=template&id=6c8498c0&scoped=true&"
import script from "./prizeInfo.vue?vue&type=script&lang=js&"
export * from "./prizeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8498c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8498c0')) {
      api.createRecord('6c8498c0', component.options)
    } else {
      api.reload('6c8498c0', component.options)
    }
    module.hot.accept("./prizeInfo.vue?vue&type=template&id=6c8498c0&scoped=true&", function () {
      api.rerender('6c8498c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeManage/prizeInfo.vue"
export default component.exports